import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import DataTable from "react-data-table-component";
import axiosInstance from "../axiosConfig";
import Swal from "sweetalert2";
import { 
  FileText, CheckCircle, CheckCircle2, AlertCircle, Clock, Eye, Edit, Edit2, 
  Trash2, RefreshCw, Filter, Search, DownloadCloud, Upload, X, ShieldAlert, ArrowLeft,
  UserCheck, Settings, CheckSquare, Plus
} from "lucide-react";
import "../assets/CSS/Dashboard.css";
import "./PurchaseInvoiceUploadModal.css";
import OCRQtyMasterModal from "../components/OCRQtyMasterModal";
import PurchaseValidationModeSwitch from "../components/PurchaseValidationModeSwitch";

// TDS Master List & Vendor Mapping
const TDS_OPTIONS = [
  { label: "TDS ON PURCHASE OF GOODS (0.10%)", value: "TDS ON PURCHASE OF GOODS", rate: 0.10 },
  { label: "TDS ON CONTRACTOR (1%)", value: "TDS ON CONTRACTOR (1%)", rate: 1.0 },
  { label: "TDS ON CONTRACTOR (2%)", value: "TDS ON CONTRACTOR (2%)", rate: 2.0 },
  { label: "TDS ON PROFESSIONAL FEES 10% (10%)", value: "TDS ON PROFESSIONAL FEES 10%", rate: 10.0 },
  { label: "TDS ON PROFESSIONAL FEES 10% (2%)", value: "TDS ON PROFESSIONAL FEES 10% (2%)", rate: 2.0 },
  { label: "TDS ON RENT FOR LAND AND BUILDING & FURNITURE (2%)", value: "TDS ON RENT FOR LAND AND BUILDING & FURNITURE (2%)", rate: 2.0 },
  { label: "TDS ON RENT FOR LAND AND BUILDING & FURNITURE (10%)", value: "TDS ON RENT FOR LAND AND BUILDING & FURNITURE (10%)", rate: 10.0 },
  { label: "NONE (0%)", value: "NONE", rate: 0 }
];

const VENDOR_TDS_MASTER = [
  { keywords: ["ABHISHEK KUMAR JAISWAL"], type: "TDS ON PROFESSIONAL FEES 10%", rate: 10 },
  { keywords: ["ALI NAJAB MOHAMMED"], type: "TDS ON PURCHASE OF GOODS", rate: 0.10 },
  { keywords: ["ALKA CORPORATION"], type: "TDS ON PURCHASE OF GOODS", rate: 0.10 },
  { keywords: ["ANTARIKSH SOFTTECH"], type: "TDS ON PURCHASE OF GOODS", rate: 0.10 },
  { keywords: ["AVINASH CARGO"], type: "TDS ON PURCHASE OF GOODS", rate: 0.10 },
  { keywords: ["B FOR U FACILITY SERVICES"], type: "TDS ON CONTRACTOR", rate: 1 },
  { keywords: ["CHARVI INDUSTRIES"], type: "TDS ON PURCHASE OF GOODS", rate: 0.10 },
  { keywords: ["CHHAJED AND DOSHI"], type: "TDS ON PROFESSIONAL FEES 10%", rate: 10 },
  { keywords: ["DELHI BOMBAY SPEED CARGO"], type: "TDS ON PURCHASE OF GOODS", rate: 0.10 },
  { keywords: ["EMPLOYEE & WORKER HEALTH CHECKUP"], type: "TDS ON PURCHASE OF GOODS", rate: 0.10 },
  { keywords: ["FIBRE TRADE LINC"], type: "TDS ON PURCHASE OF GOODS", rate: 0.10 },
  { keywords: ["GANESH ENGINEERING WORKS"], type: "TDS ON CONTRACTOR", rate: 1 },
  { keywords: ["GEET MANORAM ASSOCIATES"], type: "TDS ON CONTRACTOR", rate: 2 },
  { keywords: ["HITECH METAL FINISHERS"], type: "TDS ON CONTRACTOR", rate: 2 },
  { keywords: ["I K ENTERPRISES"], type: "TDS ON CONTRACTOR", rate: 1 },
  { keywords: ["IPFLAIR CONSULTING"], type: "TDS ON PROFESSIONAL FEES 10%", rate: 10 },
  { keywords: ["KALPANA TECHNO SERVICES"], type: "TDS ON PURCHASE OF GOODS", rate: 0.10 },
  { keywords: ["LOGIC ERP SOLUTIONS"], type: "TDS ON PROFESSIONAL FEES 10%", rate: 2 },
  { keywords: ["WELCOME ENTERPRISES"], type: "TDS ON PURCHASE OF GOODS", rate: 0.10 },
  { keywords: ["MHATRE WATER SUPPLY"], type: "TDS ON PURCHASE OF GOODS", rate: 0.10 },
  { keywords: ["MULTIMEDIA PRINT"], type: "TDS ON PURCHASE OF GOODS", rate: 0.10 },
  { keywords: ["MUSHTAK NEDARIYA"], type: "TDS ON PURCHASE OF GOODS", rate: 0.10 },
  { keywords: ["PROFESSIONL FEES"], type: "TDS ON PURCHASE OF GOODS", rate: 0.10 },
  { keywords: ["R A N K & ASSOCIATES"], type: "TDS ON PROFESSIONAL FEES 10%", rate: 10 },
  { keywords: ["RAHIB METALS PRODUCTS"], type: "TDS ON PURCHASE OF GOODS", rate: 0.10 },
  { keywords: ["SAIF CHEMICALS"], type: "TDS ON PURCHASE OF GOODS", rate: 0.10 },
  { keywords: ["SANJIV KUMAR & ASSOCIATES"], type: "TDS ON PROFESSIONAL FEES 10%", rate: 10 },
  { keywords: ["SHAH ENTERPRISES"], type: "TDS ON PURCHASE OF GOODS", rate: 0.10 },
  { keywords: ["SHAKTI TEX COATERS"], type: "TDS ON PURCHASE OF GOODS", rate: 0.10 },
  { keywords: ["SHAMS TRANS POWER"], type: "TDS ON RENT FOR LAND AND BUILDING & FURNITURE", rate: 2 },
  { keywords: ["SHREE SWAMI SAMMARATHA"], type: "TDS ON PURCHASE OF GOODS", rate: 0.10 },
  { keywords: ["SIDDHIVINAYAK ENTERPRISES"], type: "TDS ON PURCHASE OF GOODS", rate: 0.10 },
  { keywords: ["THE MEDIA PACKAGING"], type: "TDS ON PURCHASE OF GOODS", rate: 0.10 },
  { keywords: ["TRV ENT"], type: "TDS ON PURCHASE OF GOODS", rate: 0.10 },
  { keywords: ["V.M.CONTAINERS"], type: "TDS ON RENT FOR LAND AND BUILDING & FURNITURE", rate: 10 },
  { keywords: ["VIJAY KUMAR GEHLOT"], type: "TDS ON PROFESSIONAL FEES 10%", rate: 10 },
  { keywords: ["WESTERN STEEL TRADERS"], type: "TDS ON PURCHASE OF GOODS", rate: 0.10 }
];

function getVendorTdsDefaults(vendorName = "") {
  const cleanName = String(vendorName).toUpperCase().trim();
  for (const item of VENDOR_TDS_MASTER) {
    for (const kw of item.keywords) {
      if (cleanName.includes(kw)) {
        return { tdsType: item.type, tdsRate: item.rate };
      }
    }
  }
  return { tdsType: "TDS ON PURCHASE OF GOODS", tdsRate: 0.10 };
}



// ─── Helpers ─────────────────────────────────────────────────────────────────
const fmt = (n) => Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const statusConfig = {
  APPROVED: { label: "Approved",     dot: "#6366f1", bg: "#eef2ff", text: "#4338ca" },
  GREEN:    { label: "Verified",     dot: "#10b981", bg: "#ecfdf5", text: "#065f46" },
  RED:      { label: "Not Verified", dot: "#ef4444", bg: "#fef2f2", text: "#991b1b" },
};

const PURCHASE_INVOICE_FILE_EXTENSIONS = new Set(["pdf", "jpg", "jpeg", "png"]);

const formatUploadFileSize = (bytes = 0) => {
  if (!Number.isFinite(bytes) || bytes <= 0) return "0 KB";
  if (bytes < 1024 * 1024) return `${Math.max(1, Math.round(bytes / 1024))} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

// ─── StatusBadge ─────────────────────────────────────────────────────────────
const StatusBadge = ({ status }) => {
  const c = statusConfig[status] || statusConfig.RED;
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "3px 10px", borderRadius: 99, background: c.bg, color: c.text, fontSize: 11, fontWeight: 700, letterSpacing: "0.04em", whiteSpace: "nowrap" }}>
      <span style={{ width: 6, height: 6, borderRadius: "50%", background: c.dot, display: "inline-block", flexShrink: 0 }} />
      {c.label.toUpperCase()}
    </span>
  );
};

// ─── KPI Card ────────────────────────────────────────────────────────────────
const KpiCard = ({ label, value, fill, color, icon, sub }) => (
  <div style={{ background: "#fff", borderRadius: 16, border: "1px solid #e2e8f0", padding: "20px 22px", display: "flex", flexDirection: "column", gap: 10, position: "relative", overflow: "hidden" }}>
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
      <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.08em", color: "#94a3b8", textTransform: "uppercase" }}>{label}</span>
      <span style={{ fontSize: 18, color }}>{icon}</span>
    </div>
    <div style={{ fontSize: 32, fontWeight: 800, color: "#0f172a", letterSpacing: "-1px", lineHeight: 1 }}>{value}</div>
    {sub && <div style={{ fontSize: 11, color: "#64748b" }}>{sub}</div>}
    {/* Fill bar */}
    <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, height: 3, background: "#f1f5f9" }}>
      <div style={{ height: "100%", width: `${fill}%`, background: color, borderRadius: 2, transition: "width 0.8s ease" }} />
    </div>
  </div>
);

// ─── STYLES ────────────────────────────────────────────────────────────────
const S = {
  page:   { background: "#f8fafc", fontFamily: "'Inter', system-ui, sans-serif", width: "100%", minHeight: "100vh" },
  body:   { padding: "28px 28px 48px", maxWidth: 1400, margin: "0 auto", width: "100%" },
  card:   { background: "#fff", borderRadius: 16, border: "1px solid #e2e8f0", overflow: "hidden" },
  pill:   (active, color) => ({
    padding: "6px 14px", borderRadius: 99, border: "none", cursor: "pointer", fontSize: 12, fontWeight: 700,
    background: active ? color : "transparent", color: active ? "#fff" : "#64748b",
    transition: "all 0.15s",
  }),
  btn: (variant = "primary") => ({
    display: "inline-flex", alignItems: "center", gap: 6, padding: "8px 18px",
    borderRadius: 10, border: "none", cursor: "pointer", fontWeight: 700, fontSize: 13,
    background: variant === "primary" ? "#6366f1" : variant === "success" ? "#10b981" : "#f1f5f9",
    color: (variant === "ghost" || variant === "outline") ? "#475569" : "#fff",
    transition: "opacity 0.15s",
  }),
  modal: { position: "fixed", inset: 0, background: "rgba(15,23,42,0.7)", backdropFilter: "blur(6px)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 },
  modalBox: (w = 560) => ({ background: "#fff", borderRadius: 20, width: "100%", maxWidth: w, maxHeight: "90vh", overflowY: "auto", boxShadow: "0 24px 64px rgba(0,0,0,0.18)" }),
  label: { fontSize: 11, fontWeight: 700, color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 4, display: "block" },
  input: { width: "100%", padding: "10px 14px", border: "1px solid #e2e8f0", borderRadius: 10, fontSize: 13, outline: "none", fontFamily: "inherit", boxSizing: "border-box" },
};

const tableCustomStyles = {
  headCells: { style: { fontWeight: 800, color: "#64748b", textTransform: "uppercase", fontSize: 10, letterSpacing: "0.06em", background: "#f8fafc", borderBottom: "2px solid #e2e8f0" } },
  rows:      { style: { borderBottom: "1px solid #f1f5f9", minHeight: 60 } },
  cells:     { style: { paddingTop: 0, paddingBottom: 0 } },
};

export default function PurchaseInvoice() {
  const user = { Auth: "Admin" }; 

  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const toggleSidebar = () => setIsSidebarVisible(!isSidebarVisible);

  const [activeTab, setActiveTab] = useState("ALL"); 
  const [invoiceList, setInvoiceList] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedBills, setSelectedBills] = useState([]); // New state for checkboxes
  const [loading, setLoading] = useState(false);
  const [ocrResult, setOcrResult] = useState(null);

  const [showUploadModal, setShowUploadModal] = useState(false);
  const [uploadFile, setUploadFile] = useState(null);
  const [uploadPreviewUrl, setUploadPreviewUrl] = useState("");
  const [uploadError, setUploadError] = useState("");
  const [isUploadDragActive, setIsUploadDragActive] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const uploadInputRef = useRef(null);
  const [exportingId, setExportingId] = useState(null);
  const [exportingTallyId, setExportingTallyId] = useState(null);

  const [showSettingsModal, setShowSettingsModal] = useState(false);
  const [promptText, setPromptText] = useState("");
  const [isSavingPrompt, setIsSavingPrompt] = useState(false);

  const [showVendorModal, setShowVendorModal] = useState(false);
  const [vendorSearchName, setVendorSearchName] = useState("");
  const [isVerifyingVendor, setIsVerifyingVendor] = useState(false);
  const [vendorVerifyResult, setVendorVerifyResult] = useState(null);

  const [showEditModal, setShowEditModal] = useState(false);
  const [showOcrQtyModal, setShowOcrQtyModal] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [editFormData, setEditFormData] = useState({
    id: null,
    partyName: "",
    poNumber: "",
    totalAmount: "",
    loadingUnloading: "",
    transportation: "",
    transportationGst: "",
    items: []
  });

  const loadInvoices = async () => {
    try {
      setLoading(true);
      const res = await axiosInstance.get(`/api/purchase/bill/list`);
      setInvoiceList(res.data || []);
    } catch (err) {
      Swal.fire({ icon: "error", title: "Fetch Failed", text: "Something went wrong" });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadInvoices();
  }, []);

  useEffect(() => {
    if (!uploadFile || !uploadFile.type?.startsWith("image/")) {
      setUploadPreviewUrl("");
      return undefined;
    }

    const previewUrl = URL.createObjectURL(uploadFile);
    setUploadPreviewUrl(previewUrl);
    return () => URL.revokeObjectURL(previewUrl);
  }, [uploadFile]);

  useEffect(() => {
    if (!showUploadModal) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const handleEscape = (event) => {
      if (event.key === "Escape" && !isUploading) {
        setShowUploadModal(false);
        setUploadFile(null);
        setUploadError("");
        setIsUploadDragActive(false);
        setUploadProgress(0);
      }
    };

    window.addEventListener("keydown", handleEscape);
    return () => {
      window.removeEventListener("keydown", handleEscape);
      document.body.style.overflow = previousOverflow;
    };
  }, [showUploadModal, isUploading]);

  const closeUploadModal = () => {
    if (isUploading) return;
    setShowUploadModal(false);
    setUploadFile(null);
    setUploadError("");
    setIsUploadDragActive(false);
    setUploadProgress(0);
    if (uploadInputRef.current) uploadInputRef.current.value = "";
  };

  const selectUploadFile = (file) => {
    setIsUploadDragActive(false);
    setUploadError("");

    if (!file) return;

    const extension = String(file.name || "").split(".").pop().toLowerCase();
    if (!PURCHASE_INVOICE_FILE_EXTENSIONS.has(extension)) {
      setUploadFile(null);
      setUploadError("Please choose a PDF, JPG or PNG invoice file.");
      if (uploadInputRef.current) uploadInputRef.current.value = "";
      return;
    }

    if (!file.size) {
      setUploadFile(null);
      setUploadError("The selected file is empty. Please choose another invoice.");
      if (uploadInputRef.current) uploadInputRef.current.value = "";
      return;
    }

    setUploadFile(file);
  };

  const removeUploadFile = (event) => {
    event.stopPropagation();
    if (isUploading) return;
    setUploadFile(null);
    setUploadError("");
    if (uploadInputRef.current) uploadInputRef.current.value = "";
  };

  const handleUploadSubmit = async (e) => {
    e.preventDefault();
    if (!uploadFile) return;

    const formData = new FormData();
    formData.append("file", uploadFile);

    let progressInterval;
    try {
      setIsUploading(true);
      setUploadProgress(0);
      
      progressInterval = setInterval(() => {
        setUploadProgress(prev => (prev >= 95 ? prev : prev + Math.floor(Math.random() * 5) + 2));
      }, 1000);

      const res = await axiosInstance.post("/api/purchase/bill/upload", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      
      clearInterval(progressInterval);
      setUploadProgress(100);
      
      setTimeout(() => {
        setOcrResult({ ...res.data, ID: res.data.ID ?? res.data.recordId });
        setShowUploadModal(false);
        setUploadFile(null);
        setUploadProgress(0);
        setIsUploading(false);
        loadInvoices(); 
      }, 600);
      
    } catch (err) {
      clearInterval(progressInterval);
      setUploadProgress(0);
      setIsUploading(false);
      let errorMsg = err.response?.data?.message || "OCR Processing failed";
      Swal.fire({ icon: "error", title: "Action Required", text: errorMsg, confirmButtonColor: "#ef4444" });
    }
  };

  const handleApprove = async (id) => {
    Swal.fire({ title: 'Approve this invoice?', text: "Once approved, it cannot be deleted or edited.", icon: 'question', showCancelButton: true }).then(async (res) => {
      if(res.isConfirmed) {
        try {
          const response = await axiosInstance.put(`/api/purchase/bill/approve/${id}`);
          Swal.fire('Approved!', response.data.message || 'Invoice approved successfully.', 'success');
          loadInvoices();
        } catch (err) {
          Swal.fire('Error', err.response?.data?.message || 'Failed to approve invoice.', 'error');
        }
      }
    });
  };

  const handleDelete = (id) => {
    Swal.fire({ title: 'Delete record?', icon: 'warning', showCancelButton: true }).then(async (res) => {
      if(res.isConfirmed) {
        await axiosInstance.delete(`/api/purchase/bill/delete/${id}`);
        loadInvoices();
      }
    });
  };

  /* ================= EXPORT HANDLER ================= */
  const handleExportExcel = async (exportId = null) => {
    try {
      setExportingId(exportId || 'ALL');
      
      let url = '/api/purchase/bill/export';
      if (exportId && exportId !== 'ALL') {
        url = `/api/purchase/bill/export?id=${exportId}`;
      } else if (selectedBills.length > 0) {
        url = `/api/purchase/bill/export?ids=${selectedBills.join(',')}`;
      } else if (activeTab === 'APPROVED') {
        url = '/api/purchase/bill/export'; 
      } else {
        Swal.fire("Info", "Please select bills to export.", "info");
        setExportingId(null);
        return;
      }

      const res = await axiosInstance.get(url, { responseType: 'blob' });
      const blobUrl = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = blobUrl;
      link.setAttribute('download', (exportId && exportId !== 'ALL') ? `Purchase_Bill_${exportId}.xlsx` : `Purchase_Bills_${new Date().toISOString().split('T')[0]}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (err) {
      Swal.fire("Export Failed", "Failed to download the Excel file.", "error");
    } finally {
      setExportingId(null);
    }
  };

  const handleExportTally = async (exportId = null) => {
    try {
      setExportingTallyId(exportId || 'ALL');
      
      let url = '/api/purchase/bill/export/tally';
      if (exportId && exportId !== 'ALL') {
        url = `/api/purchase/bill/export/tally?id=${exportId}`;
      } else if (selectedBills.length > 0) {
        url = `/api/purchase/bill/export/tally?ids=${selectedBills.join(',')}`;
      } else if (activeTab === 'APPROVED') {
        url = '/api/purchase/bill/export/tally'; 
      } else {
        Swal.fire("Info", "Please select bills to export to Tally Format.", "info");
        setExportingTallyId(null);
        return;
      }

      const res = await axiosInstance.get(url, { responseType: 'blob' });
      const blobUrl = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = blobUrl;
      link.setAttribute('download', exportId ? `Purchase_Bill_Tally_${exportId}.xlsx` : `Purchase_Bills_Tally_${new Date().toISOString().split('T')[0]}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (err) {
      Swal.fire("Export Failed", "Failed to download the Tally Excel file.", "error");
    } finally {
      setExportingTallyId(null);
    }
  };

  const fetchPrompt = async () => {
    try {
      const res = await axiosInstance.get("/api/purchase/settings/prompt");
      setPromptText(res.data.prompt);
      setShowSettingsModal(true);
    } catch (err) {
      Swal.fire("Error", "Could not fetch AI prompt settings.", "error");
    }
  };

  const handleSavePrompt = async () => {
    try {
      setIsSavingPrompt(true);
      await axiosInstance.post("/api/purchase/settings/prompt", { promptText });
      Swal.fire("Saved", "AI Prompt updated successfully!", "success");
      setShowSettingsModal(false);
    } catch (err) {
      Swal.fire("Error", "Failed to update prompt.", "error");
    } finally {
      setIsSavingPrompt(false);
    }
  };

  const handleVerifyVendor = async (e) => {
    e.preventDefault();
    if (!vendorSearchName.trim()) return;
    try {
      setIsVerifyingVendor(true);
      setVendorVerifyResult(null);
      const res = await axiosInstance.post("/api/purchase/vendor/verify", { vendorName: vendorSearchName });
      setVendorVerifyResult(res.data);
    } catch (err) {
      Swal.fire("Error", err.response?.data?.message || "Failed to search vendor.", "error");
    } finally {
      setIsVerifyingVendor(false);
    }
  };

  /* ================= EDIT HANDLERS (AUTO CALCULATION) ================= */
  const handleEditOpen = (row) => {
    let parsedItems = [];
    let taxSource = row.data || {};
    let isDetailsView = !!row.data; // true if it's ocrResponse from the detailed view

    let lu = "";
    let tr = "";
    let trGst = "";
    let trLocal = "";
    let tdsType = "";
    let tdsRate = "";

    const partyName = isDetailsView ? (row.data.partyName || "") : (row.PartyName || "");

    if (isDetailsView) {
      parsedItems = Array.isArray(row.data.items) ? row.data.items : [];
      lu = row.data.loadingUnloading || "";
      tr = row.data.transportation || "";
      trGst = row.data.transportationGst || "";
      trLocal = row.data.transportationLocalScheme || "";
      tdsType = row.data.tdsType || "";
      tdsRate = row.data.tdsRate !== undefined && row.data.tdsRate !== null ? row.data.tdsRate : "";
    } else {
      try {
        const rawParsed = JSON.parse(row.ExtractedItems || "{}");
        taxSource = rawParsed || {};
        if (Array.isArray(rawParsed)) {
          parsedItems = rawParsed;
        } else {
          parsedItems = rawParsed.items || [];
          lu = rawParsed.loadingUnloading || "";
          tr = rawParsed.transportation || "";
          trGst = rawParsed.transportationGst || "";
          trLocal = rawParsed.transportationLocalScheme || "";
          tdsType = rawParsed.tdsType || "";
          tdsRate = rawParsed.tdsRate !== undefined && rawParsed.tdsRate !== null ? rawParsed.tdsRate : "";
        }
      } catch (e) { parsedItems = []; }
    }

    // Auto-fill TDS defaults if not set
    if (!tdsType || tdsRate === "") {
      const defs = getVendorTdsDefaults(partyName);
      tdsType = tdsType || defs.tdsType;
      tdsRate = tdsRate !== "" ? tdsRate : defs.tdsRate;
    }

    setEditFormData({
      id: row.ID ?? row.recordId,
      ...Object.fromEntries(["taxableAmount", "cgst", "sgst", "igst"].map(key => [key, taxSource[key] ?? undefined])),
      partyName: partyName,
      poNumber: isDetailsView ? (row.data.poNumber || "") : (row.PONumber || ""),
      totalAmount: isDetailsView ? (row.data.totalAmount || "") : (row.TotalAmount || ""),
      loadingUnloading: lu,
      transportation: tr,
      transportationGst: trGst,
      transportationLocalScheme: trLocal,
      tdsType: tdsType,
      tdsRate: tdsRate,
      items: parsedItems
    });
    setShowEditModal(true);
  };

  const handleEditItemChange = (index, field, value) => {
    const newItems = editFormData.items.map(item => ({ ...item }));
    newItems[index][field] = value;

    // AUTO CALCULATION LOGIC: Amount = Qty * Rate
    if (field === "qty" || field === "rate") {
      const q = parseFloat(newItems[index].qty) || 0;
      const r = parseFloat(newItems[index].rate) || 0;
      newItems[index].amount = (q * r).toFixed(2);
    }

    // Auto Calculate Grand Total
    const newTotalAmount = newItems.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0);

    setEditFormData({ 
      ...editFormData, 
      items: newItems, 
      totalAmount: (Number(editFormData.totalAmount || 0) + newTotalAmount - editFormData.items.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0 )).toFixed(2)
    });
  };

  const handleFetchPoItems = async () => {
    if (!editFormData.poNumber || editFormData.poNumber.trim() === "") {
      Swal.fire("Warning", "Please enter a PO Number first.", "warning");
      return;
    }

    const confirmResult = await Swal.fire({
      title: "Are you sure?",
      text: "This will delete all current extracted items and replace them with PO items.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, fetch and replace!"
    });

    if (!confirmResult.isConfirmed) return;

    try {
      Swal.fire({ title: 'Fetching PO Items...', allowOutsideClick: false, didOpen: () => { Swal.showLoading(); } });
      const res = await axiosInstance.get(`/api/purchase/po/items/${encodeURIComponent(editFormData.poNumber.trim())}`, {
        params: { partyName: editFormData.partyName }
      });
      if (res.data.success) {
        if (res.data.items && res.data.items.length > 0) {
          setEditFormData({
            ...editFormData,
            items: res.data.items.map(i => ({
              name: i.name || i.description || "",
              qty: i.qty || "",
              rate: i.rate || "",
              amount: i.amount || "0.00"
            })),
            totalAmount: editFormData.totalAmount
          });
          Swal.fire("Success", "PO Items fetched successfully!", "success");
        } else {
          Swal.fire("Info", "No items found for this PO Number.", "info");
        }
      } else {
        Swal.fire("Error", res.data.message || "Failed to fetch PO items", "error");
      }
    } catch (err) {
      Swal.fire("Error", "API Error: " + err.message, "error");
    }
  };

  const handleAddItemRow = () => {
    setEditFormData({
      ...editFormData,
      items: [...editFormData.items, { name: "", qty: "", rate: "", amount: "0.00" }]
    });
  };

  const handleRemoveItemRow = (index) => {
    const newItems = editFormData.items.filter((_, i) => i !== index);
    const newTotalAmount = newItems.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0);
    setEditFormData({ ...editFormData, items: newItems, totalAmount: (Number(editFormData.totalAmount || 0) + newTotalAmount - editFormData.items.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0)).toFixed(2) });
  };

  const handleUpdateSubmit = async (e) => {
    e.preventDefault();
    if (!Number.isInteger(Number(editFormData.id)) || Number(editFormData.id) <= 0) {
      Swal.fire("Error", "Bill ID is missing. Reopen this bill from the dashboard before saving.", "error");
      return;
    }
    let saved = false;
    try {
      setIsUpdating(true);
      await axiosInstance.put(`/api/purchase/bill/update/${editFormData.id}`, editFormData);
      saved = true;
      
      // Call details API silently to trigger backend status recalculation & auto-update
      const detailsRes = await axiosInstance.get(`/api/purchase/bill/details/${editFormData.id}`);
      
      // If the detailed view is currently open for THIS bill, update it to reflect the new data!
      if (ocrResult && ocrResult.ID === editFormData.id) {
        const details = detailsRes.data;
        let parsedItems = [];
        let parsedRaw = {};
        try {
          parsedRaw = JSON.parse(details.ExtractedItems || "{}");
          parsedItems = Array.isArray(parsedRaw) ? parsedRaw : (parsedRaw.items || []);
        } catch (e) { parsedItems = []; }

        setOcrResult({
          ID: details.ID,
          status: details.Status,
          mismatchDetails: details.MismatchReasons,
          data: {
            ...parsedRaw,
            partyName: details.PartyName,
            poNumber: details.PONumber,
            date: details.BillDate ? new Date(details.BillDate).toISOString().split("T")[0] : "N/A",
            totalAmount: details.TotalAmount,
            items: parsedItems,
            loadingUnloading: parsedRaw.loadingUnloading || "",
            transportation: parsedRaw.transportation || "",
            transportationGst: parsedRaw.transportationGst || "",
            transportationLocalScheme: parsedRaw.transportationLocalScheme || "",
            tdsType: parsedRaw.tdsType || "",
            tdsRate: parsedRaw.tdsRate !== undefined ? parsedRaw.tdsRate : ""
          }
        });
      }
      
      Swal.fire("Updated", "Record updated successfully!", "success");
      setShowEditModal(false);
      loadInvoices(); 
    } catch (err) {
      Swal.fire(saved ? "Saved; reload failed" : "Save failed", saved ? "Your changes were saved, but bill details could not reload. Reopen the bill from the dashboard." : (err.response?.data?.message || err.message || "Failed to update record."), saved ? "warning" : "error");
    } finally {
      setIsUpdating(false);
    }
  };

  const handleViewDetails = async (row) => {

    try {

      const res = await axiosInstance.get(
        `/api/purchase/bill/details/${row.ID}`
      );

      const details = res.data;

      let parsedItems = [];
      let parsedRaw = {};

      try {
        parsedRaw = JSON.parse(
          details.ExtractedItems || "{}"
        );

        parsedItems = Array.isArray(parsedRaw)
          ? parsedRaw
          : (parsedRaw.items || []);

      } catch (e) {

        parsedItems = [];

      }

      setOcrResult({
        ID: details.ID,
        status: details.Status,
        mismatchDetails: details.MismatchReasons,
        data: {
          ...parsedRaw,
          partyName: details.PartyName,
          poNumber: details.PONumber,
          date: details.BillDate
            ? new Date(details.BillDate)
                .toISOString()
                .split("T")[0]
            : "N/A",
          totalAmount: details.TotalAmount,
          items: parsedItems,
          loadingUnloading: parsedRaw.loadingUnloading || "",
          transportation: parsedRaw.transportation || "",
          transportationGst: parsedRaw.transportationGst || "",
          transportationLocalScheme: parsedRaw.transportationLocalScheme || "",
          tdsType: parsedRaw.tdsType || "",
          tdsRate: parsedRaw.tdsRate !== undefined ? parsedRaw.tdsRate : ""
        }
      });

      // Reload invoices in background so the list reflects any DB auto-updates (e.g. status changes)
      loadInvoices();

      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });

    } catch (err) {

      Swal.fire(
        "Error",
        err.response?.data?.message ||
        "Failed to fetch details",
        "error"
      );

    }

  };

  const iconBtn = (color) => ({
    background: "none", border: "none", cursor: "pointer", padding: "4px 6px",
    borderRadius: 6, fontSize: 15, transition: "background 0.15s", color: color
  });

  const columns = [
    {
      name: "Vendor / Party",
      sortable: true,
      selector: r => r.PartyName,
      cell: r => (
        <div style={{ padding: "12px 0", cursor: "pointer" }} onClick={() => handleViewDetails(r)}>
          <div style={{ fontWeight: 700, color: "#6366f1", fontSize: 13, marginBottom: 2 }}>{r.PartyName}</div>
          <div style={{ fontSize: 11, color: "#94a3b8", fontFamily: "monospace" }}>#{r.ID}</div>
        </div>
      ),
    },
    {
      name: "Items",
      grow: 2,
      cell: r => {
        let items = [];
        try { 
          const parsed = JSON.parse(r.ExtractedItems || "[]"); 
          items = Array.isArray(parsed) ? parsed : (parsed.items || []);
        } catch {}
        return (
          <div style={{ padding: "8px 0", width: "100%" }}>
            {items.slice(0, 2).map((it, i) => (
              <div key={i} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "4px 8px", background: "#f8fafc", borderRadius: 6, marginBottom: 4, borderLeft: "3px solid #6366f1", fontSize: 11 }}>
                <span style={{ fontWeight: 600, color: "#1e293b", maxWidth: 140, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{it.name || it.description || 'Unknown'}</span>
                <span style={{ fontFamily: "monospace", color: "#6366f1", fontWeight: 700, marginLeft: 8 }}>₹{fmt(it.amount)}</span>
              </div>
            ))}
            {items.length > 2 && <div style={{ fontSize: 10, color: "#94a3b8", paddingLeft: 8 }}>+{items.length - 2} more items</div>}
          </div>
        );
      },
    },
    {
      name: "PO Number",
      sortable: true,
      selector: r => r.PONumber,
      cell: r => <span style={{ fontFamily: "monospace", fontSize: 12, fontWeight: 600, color: "#475569" }}>{r.PONumber || "—"}</span>,
    },
    {
      name: "Amount",
      sortable: true,
      selector: r => parseFloat(r.TotalAmount),
      cell: r => <span style={{ fontFamily: "monospace", fontWeight: 800, fontSize: 13, color: "#0f172a" }}>₹{fmt(r.TotalAmount)}</span>,
    },
    {
      name: "Status",
      cell: r => <StatusBadge status={r.Status} />,
    },
    {
      name: "Date",
      selector: r => r.CreatedAt,
      cell: r => <span style={{ fontSize: 11, color: "#64748b" }}>{new Date(r.CreatedAt).toLocaleDateString("en-GB")}</span>,
    },
    {
      name: "Actions",
      minWidth: "120px",
      cell: r => r.Status === "APPROVED" ? (
        <span style={{ fontSize: 11, color: "#94a3b8", fontWeight: 600 }}>☑ Locked</span>
      ) : (
        <div style={{ display: "flex", gap: 12 }}>
          <button onClick={() => handleEditOpen(r)} title="Edit" style={iconBtn("#6366f1")}><Edit size={16}/></button>
          <button onClick={() => handleApprove(r.ID)} title="Approve" style={iconBtn("#10b981")}><CheckCircle size={16}/></button>
          <button onClick={() => handleDelete(r.ID)} title="Delete" style={iconBtn("#ef4444")}><Trash2 size={16}/></button>
        </div>
      ),
    },
  ];

  const displayedInvoices = invoiceList.filter(item => {
    if (activeTab === "NOT VERIFIED") return item.Status === 'RED';
    if (activeTab === "VERIFIED") return item.Status === 'GREEN';
    if (activeTab === "APPROVED") return item.Status === 'APPROVED';
    return true;
  });

  const filteredData = displayedInvoices.filter(item => 
    item.PartyName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    item.PONumber?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const stats = {
    total: invoiceList.length,
    pending: invoiceList.filter(i => i.Status === 'RED').length,
    verified: invoiceList.filter(i => i.Status === 'GREEN').length,
    approved: invoiceList.filter(i => i.Status === 'APPROVED').length,
  };

  return (
    <div className="d-flex dashboard bg-light">
      <div className={isSidebarVisible ? "sidebar-container" : "sidebar-hidden"}>
        <Sidebar />
      </div>

      <div className="flex-grow-1">
        <Header toggleSidebar={toggleSidebar} isSidebarVisible={isSidebarVisible} />

        <main className="main-container p-4 text-start purchase-invoice-main" style={{ fontFamily: "'Inter', system-ui, sans-serif" }}>
          <PurchaseValidationModeSwitch />
          {/* ── PAGE TITLE & TOOLBAR ── */}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", marginBottom: 24, flexWrap: "wrap", gap: 16 }}>
            <div>
              <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
                <div style={{ width: 28, height: 28, borderRadius: 8, background: "#e0e7ff", color: "#4f46e5", display: "flex", alignItems: "center", justifyContent: "center" }}><FileText size={16}/></div>
                <span style={{ color: "#4f46e5", fontWeight: 800, fontSize: 13, textTransform: "uppercase", letterSpacing: "0.05em" }}>PurchaseBrain</span>
              </div>
              <h1 style={{ fontSize: 28, fontWeight: 900, color: "#0f172a", margin: 0, letterSpacing: "-0.5px" }}>Purchase Bill Intelligence</h1>
              <p style={{ color: "#64748b", fontSize: 14, margin: "6px 0 0" }}>Automated OCR Extraction & Database Validation</p>
            </div>
            
            <div style={{ display: "flex", gap: 10, alignItems: "center", background: "#fff", padding: "6px 8px", borderRadius: 12, border: "1px solid #e2e8f0", boxShadow: "0 1px 2px rgba(0,0,0,0.02)" }}>
              <button onClick={() => { setShowVendorModal(true); setVendorSearchName(""); setVendorVerifyResult(null); }} style={{ ...S.btn("ghost"), color: "#475569", fontSize: 13 }}><UserCheck size={16}/> Vendor Lookup</button>
              {(user?.Auth === "Admin" || user?.Auth === "SuperAdmin") && (
                <>
                  <div style={{ width: 1, height: 20, background: "#e2e8f0", margin: "0 4px" }} />
                  <button onClick={fetchPrompt} style={{ ...S.btn("ghost"), color: "#475569", fontSize: 13 }}><Settings size={16}/> Prompt</button>
                  <div style={{ width: 1, height: 20, background: "#e2e8f0", margin: "0 4px" }} />
                  <button onClick={() => setShowOcrQtyModal(true)} style={{ ...S.btn("ghost"), color: "#475569", fontSize: 13 }}><Settings size={16}/> Qty Master</button>
                </>
              )}
              <div style={{ width: 1, height: 20, background: "#e2e8f0", margin: "0 4px" }} />
              <button onClick={() => setShowUploadModal(true)} style={{ ...S.btn(), background: "#4f46e5" }}><Upload size={16}/> Upload Bill</button>
            </div>
          </div>

          {/* ── KPI GRID ── */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 16, marginBottom: 24 }}>
            <KpiCard label="Total Bills"    value={stats.total}    fill={100}                            color="#6366f1" icon={<FileText size={24} color="#6366f1"/>} sub="All time" />
            <KpiCard label="Not Verified"   value={stats.pending}  fill={stats.total ? stats.pending  / stats.total * 100 : 0} color="#ef4444" icon={<AlertCircle size={24} color="#ef4444"/>} sub="Needs review" />
            <KpiCard label="Verified"       value={stats.verified} fill={stats.total ? stats.verified / stats.total * 100 : 0} color="#10b981" icon={<CheckCircle size={24} color="#10b981"/>} sub="Awaiting approval" />
            <KpiCard label="Approved"       value={stats.approved} fill={stats.total ? stats.approved / stats.total * 100 : 0} color="#6366f1" icon={<CheckSquare size={24} color="#6366f1"/>} sub="Ready for Tally" />
          </div>

          {/* ── LEGEND STRIP ── */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 12, marginBottom: 24 }}>
            {[
              { color: "#fef2f2", border: "#fca5a5", dot: "#ef4444", title: "Not Verified", desc: "AI extracted data but items didn't match PO. Needs manual review." },
              { color: "#ecfdf5", border: "#86efac", dot: "#10b981", title: "Verified",     desc: "AI perfectly matched items with PO. Awaiting approval." },
              { color: "#eef2ff", border: "#a5b4fc", dot: "#6366f1", title: "Approved",     desc: "Bill is locked and approved. Ready to export to Tally." },
            ].map(l => (
              <div key={l.title} style={{ background: l.color, border: `1px solid ${l.border}`, borderRadius: 12, padding: "12px 16px", display: "flex", gap: 10 }}>
                <div style={{ width: 8, height: 8, borderRadius: "50%", background: l.dot, marginTop: 5, flexShrink: 0 }} />
                <div>
                  <div style={{ fontWeight: 700, fontSize: 11, color: "#1e293b", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 2 }}>{l.title}</div>
                  <div style={{ fontSize: 12, color: "#475569", lineHeight: 1.5 }}>{l.desc}</div>
                </div>
              </div>
            ))}
          </div>

          {/* ── CONDITIONAL VIEW ── */}
          {ocrResult ? (
            <div className="animate__animated animate__fadeIn">
              <InvoiceResultView 
                ocrResponse={ocrResult} 
                onExport={handleExportExcel} 
                exportingId={exportingId}
                onExportTally={handleExportTally}
                exportingTallyId={exportingTallyId}
                onEdit={handleEditOpen}
                onBack={() => setOcrResult(null)}
              />
              <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 24 }}>
                <button onClick={() => setOcrResult(null)} style={{ ...S.btn("ghost"), border: "1px solid #e2e8f0" }}>← Back to Dashboard</button>
              </div>
            </div>
          ) : (
            <div style={S.card}>
              {/* Toolbar */}
              <div style={{ padding: "16px 20px", borderBottom: "1px solid #f1f5f9", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 12 }}>
                {/* Tabs */}
                <div style={{ display: "flex", gap: 4, background: "#f8fafc", borderRadius: 12, padding: 4 }}>
                  {[
                    { id: "ALL",          label: "All",          count: stats.total,    color: "#6366f1" },
                    { id: "NOT VERIFIED", label: "Not Verified", count: stats.pending,  color: "#ef4444" },
                    { id: "VERIFIED",     label: "Verified",     count: stats.verified, color: "#10b981" },
                    { id: "APPROVED",     label: "Approved",     count: stats.approved, color: "#6366f1" },
                  ].map(t => (
                    <button key={t.id} onClick={() => setActiveTab(t.id)} style={S.pill(activeTab === t.id, t.color)}>
                      {t.label} <span style={{ opacity: 0.75 }}>({t.count})</span>
                    </button>
                  ))}
                </div>

                {/* Right: search + export */}
                <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                  <div style={{ position: "relative" }}>
                    <span style={{ position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)", display: "flex" }}><Search size={14} color="#94a3b8"/></span>
                    <input
                      value={searchQuery}
                      onChange={e => setSearchQuery(e.target.value)}
                      placeholder="Search vendor or PO…"
                      style={{ ...S.input, paddingLeft: 32, width: 220, background: "#f8fafc", border: "1px solid #e2e8f0" }}
                    />
                  </div>
                  <button onClick={() => handleExportExcel()} disabled={exportingId === 'ALL'} style={{ ...S.btn("success"), fontSize: 12, display: "flex", gap: 6, alignItems: "center" }}>
                    <DownloadCloud size={14}/> {exportingId === 'ALL' ? "Exporting..." : "Excel"}
                  </button>
                  <button onClick={() => handleExportTally('ALL')} disabled={exportingTallyId === 'ALL'} style={{ ...S.btn(), fontSize: 12, display: "flex", gap: 6, alignItems: "center" }}>
                    <DownloadCloud size={14}/> {exportingTallyId === 'ALL' ? "Exporting..." : "Tally Format"}
                  </button>
                </div>
              </div>

              {/* Table */}
              <DataTable
                columns={columns}
                data={filteredData}
                pagination
                progressPending={loading}
                highlightOnHover
                responsive
                selectableRows
                onSelectedRowsChange={(state) => setSelectedBills(state.selectedRows.map(r => r.ID))}
                customStyles={tableCustomStyles}
                progressComponent={<div style={{ padding: 40, color: "#94a3b8" }}>Loading invoices…</div>}
                noDataComponent={<div style={{ padding: 48, color: "#94a3b8", textAlign: "center" }}>No records match the current filter.</div>}
              />
            </div>
          )}
        </main>
      </div>

      {/* ================= VENDOR VERIFY MODAL ================= */}
      {showVendorModal && (
        <div className="modal show d-block" style={{backgroundColor: 'rgba(15, 23, 42, 0.6)', backdropFilter: 'blur(4px)', zIndex: 1055}}>
          <div className="modal-dialog modal-xl modal-dialog-centered">
            <div className="modal-content border-0 shadow-lg rounded-4 overflow-hidden">
              <div className="modal-header border-0 bg-white px-4 pt-4 pb-2">
                <h5 className="fw-black mb-0 d-flex align-items-center gap-3 text-dark">
                  <div className="p-2 bg-primary bg-opacity-10 text-primary rounded-circle d-flex"><UserCheck size={22} /></div>
                  Vendor & PO Lookup
                </h5>
                <button type="button" className="btn-close shadow-none" onClick={() => setShowVendorModal(false)}></button>
              </div>
              <form onSubmit={handleVerifyVendor}>
                <div className="modal-body px-4 pb-4 pt-3">
                  <div className="input-group input-group-lg mb-4 shadow-sm rounded-3 overflow-hidden border">
                    <span className="input-group-text bg-light border-0 text-muted ps-3 pr-2"><Search size={20} /></span>
                    <input type="text" className="form-control border-0 bg-light shadow-none fs-6" placeholder="Search Vendor Party or PO Number..." value={vendorSearchName} onChange={(e) => setVendorSearchName(e.target.value)} required />
                    <button type="submit" className="btn btn-primary px-4 fw-bold" disabled={isVerifyingVendor}>{isVerifyingVendor ? "Searching..." : "Search"}</button>
                  </div>
                  {vendorVerifyResult && (
                    <div className="animate__animated animate__fadeIn">
                      {vendorVerifyResult.found ? (
                        <div className="bg-success bg-opacity-10 border border-success border-opacity-25 rounded-4 p-3">
                          <div className="d-flex align-items-center gap-2 mb-3">
                            <CheckCircle size={20} className="text-success"/>
                            <h6 className="fw-bold text-success mb-0">{vendorVerifyResult.message}</h6>
                          </div>
                          {vendorVerifyResult.matches && vendorVerifyResult.matches.length > 0 && (
                            <div className="mt-3">
                              <h6 className="fw-bold text-muted small text-uppercase mb-2 px-1">Tally Ledger Matches</h6>
                              <div className="bg-white rounded-3 shadow-sm border" style={{maxHeight: '200px', overflowY: 'auto', overflowX: 'hidden'}}>
                                <div className="list-group list-group-flush">
                                  {vendorVerifyResult.matches.map((name, idx) => (
                                    <div key={idx} className="list-group-item d-flex align-items-center gap-3 py-2 border-bottom text-dark hover-bg-light transition-all">
                                      <div className="bg-light rounded-circle d-flex align-items-center justify-content-center text-muted border flex-shrink-0" style={{width: '28px', height: '28px'}}>
                                        <span className="fw-bold" style={{fontSize: '11px'}}>{idx + 1}</span>
                                      </div>
                                      <span className="fw-medium" style={{fontSize: '13px', wordBreak: 'break-word'}}>{name}</span>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          )}
                          
                          {vendorVerifyResult.poMatches && vendorVerifyResult.poMatches.length > 0 && (
                            <div className="mt-3">
                              <h6 className="fw-bold text-muted small text-uppercase mb-2 px-1">PO Database Matches</h6>
                              <div className="bg-white rounded-3 shadow-sm border" style={{maxHeight: '450px', overflowY: 'auto'}}>
                                <div className="table-responsive">
                                  <table className="table table-hover table-bordered mb-0" style={{fontSize: '0.8rem'}}>
                                    <thead className="table-dark sticky-top">
                                      <tr>
                                        <th className="py-2 text-white fw-bold">PO Number</th>
                                        <th className="py-2 text-white fw-bold">Supplier</th>
                                        <th className="py-2 text-white fw-bold">Item Name</th>
                                        <th className="py-2 text-white fw-bold">Item Desc</th>
                                        <th className="py-2 text-white fw-bold">Group</th>
                                        <th className="py-2 text-white fw-bold">Lot Number</th>
                                        <th className="py-2 text-white fw-bold text-end">Rate</th>
                                        <th className="py-2 text-white fw-bold text-end">PO Qty</th>
                                        <th className="py-2 text-white fw-bold text-end">Amount</th>
                                        <th className="py-2 text-white fw-bold text-end">Override</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {vendorVerifyResult.poMatches.map((po, idx) => (
                                        <tr key={idx} className="align-middle">
                                          <td className="py-2 fw-bold text-primary">{po.poNumber}</td>
                                          <td className="py-2">{po.supplierName}</td>
                                          <td className="py-2">{po.itemName}</td>
                                          <td className="py-2 text-muted">{po.itemDesc}</td>
                                          <td className="py-2">{po.groupName || '-'}</td>
                                          <td className="py-2">{po.lotNumber || '-'}</td>
                                          <td className="py-2 text-end fw-bold">₹{po.rate}</td>
                                          <td className="py-2 text-end">{po.qty}</td>
                                          <td className="py-2 text-end text-success fw-bold">₹{po.amount || '0.00'}</td>
                                          <td className="py-2 text-end">
                                            {po.qtyOverride ? (
                                              <span className="badge bg-warning text-dark px-2 py-1">{po.qtyOverride}</span>
                                            ) : (
                                              <span className="text-muted">-</span>
                                            )}
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      ) : (
                        <div className="bg-danger bg-opacity-10 border border-danger border-opacity-25 rounded-4 p-4 text-center">
                          <div className="mb-2"><AlertCircle size={36} className="text-danger opacity-75"/></div>
                          <h6 className="fw-bold text-danger mb-1">Vendor Not Found</h6>
                          <p className="small text-danger opacity-75 mb-0">{vendorVerifyResult.message}</p>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* ================= EDIT RECORD MODAL (READ ONLY AMOUNTS) ================= */}
      {showEditModal && (
        <div className="modal show d-block" style={{backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1055}}>
          <div className="modal-dialog modal-xl modal-dialog-centered">
            <div className="modal-content border-0 shadow-lg rounded-4 overflow-hidden">
              <div className="modal-header border-0 bg-primary text-white p-4">
                <h5 className="fw-bold mb-0 d-flex align-items-center gap-2"><Edit size={20}/> Manual Edit Mode</h5>
                <button type="button" className="btn-close btn-close-white" onClick={() => setShowEditModal(false)}></button>
              </div>
              
              <form onSubmit={handleUpdateSubmit}>
                <div className="modal-body p-4 bg-light">
                  <div className="row g-3 mb-4">
                    <div className="col-md-5">
                      <label className="fw-bold text-muted small mb-1 text-uppercase">Vendor Name</label>
                      <input type="text" className="form-control fw-bold" value={editFormData.partyName} onChange={(e) => setEditFormData({...editFormData, partyName: e.target.value})} required />
                    </div>
                    <div className="col-md-3">
                      <label className="fw-bold text-muted small mb-1 text-uppercase">PO Number</label>
                      <input type="text" className="form-control fw-bold" value={editFormData.poNumber} onChange={(e) => setEditFormData({...editFormData, poNumber: e.target.value})} />
                    </div>
                    <div className="col-md-4">
                      {/* Invoice total can be corrected against the original bill. */}
                      <label className="fw-bold text-muted small mb-1 text-uppercase">Grand Total (₹)</label>
                      <input type="number" step="any" className="form-control fw-bold text-primary bg-light" value={editFormData.totalAmount} min="0" required onChange={(e) => setEditFormData({...editFormData, totalAmount: e.target.value})} />
                    </div>
                  </div>

                  <div className="mb-4 p-3 rounded border">
                    <div className="fw-bold mb-2">Invoice Tax Amounts (₹)</div>
                    <p className="small text-muted">Enter amounts from the invoice. Verify Grand Total against the invoice after correcting taxes.</p>
                    <div className="row g-3">
                      {[["taxableAmount", "Taxable Amount"], ["cgst", "Input CGST"], ["sgst", "Input SGST"], ["igst", "Input IGST"]].map(([field, label]) => (
                        <div className="col-md-3" key={field}>
                          <label htmlFor={`invoice-${field}`} className="form-label small fw-bold">{label}</label>
                          <input id={`invoice-${field}`} type="number" min="0" step="0.01" className="form-control"
                            value={editFormData[field] ?? ""}
                            onChange={(e) => setEditFormData({...editFormData, [field]: e.target.value === "" ? undefined : e.target.value})} />
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Additional Charges (Applied to entire bill) */}
                  <div className="mb-4 bg-light p-3 rounded border">
                    <label className="fw-bold text-dark mb-3">Additional Charges (Applied to entire bill)</label>
                    <div className="row g-3">
                      <div className="col-md-3">
                        <label className="form-label small fw-bold text-muted mb-1">Loading/Unloading (₹)</label>
                        <input type="number" step="any" min="0" className="form-control" value={editFormData.loadingUnloading || ""} onChange={(e) => setEditFormData({...editFormData, loadingUnloading: e.target.value})} placeholder="0.00"/>
                      </div>
                      <div className="col-md-3">
                        <label className="form-label small fw-bold text-muted mb-1">Transportation (₹)</label>
                        <input type="number" step="any" min="0" className="form-control" value={editFormData.transportation || ""} onChange={(e) => setEditFormData({...editFormData, transportation: e.target.value})} placeholder="0.00"/>
                      </div>
                      <div className="col-md-3">
                        <label className="form-label small fw-bold text-muted mb-1">Transportation with GST (₹)</label>
                        <input type="number" step="any" min="0" className="form-control" value={editFormData.transportationGst || ""} onChange={(e) => setEditFormData({...editFormData, transportationGst: e.target.value})} placeholder="0.00"/>
                      </div>
                      <div className="col-md-3">
                        <label className="form-label small fw-bold text-muted mb-1">Transportation(Local)/Scheme(₹)</label>
                        <input type="number" step="any" min="0" className="form-control" value={editFormData.transportationLocalScheme || ""} onChange={(e) => setEditFormData({...editFormData, transportationLocalScheme: e.target.value})} placeholder="0.00"/>
                      </div>
                    </div>
                  </div>

                  {/* TDS Section */}
                  <div className="mb-4 p-3 rounded border" style={{ background: "#eff6ff", borderColor: "#bfdbfe" }}>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <label className="fw-bold text-primary mb-0">TDS Configuration (Tax Deducted at Source)</label>
                      <span className="badge bg-primary text-white">Auto Applied for Tally Export</span>
                    </div>
                    <div className="row g-3">
                      <div className="col-md-8">
                        <label className="form-label small fw-bold text-muted mb-1">TDS TYPE NAME</label>
                        <select 
                          className="form-select fw-bold text-dark" 
                          value={editFormData.tdsType || "TDS ON PURCHASE OF GOODS"}
                          onChange={(e) => {
                            const val = e.target.value;
                            const matched = TDS_OPTIONS.find(o => o.value === val);
                            setEditFormData({
                              ...editFormData,
                              tdsType: val,
                              tdsRate: matched ? matched.rate : editFormData.tdsRate
                            });
                          }}
                        >
                          {TDS_OPTIONS.map((opt, idx) => (
                            <option key={idx} value={opt.value}>{opt.label}</option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-4">
                        <label className="form-label small fw-bold text-muted mb-1">TDS RATE (%)</label>
                        <input 
                          type="number" 
                          step="any" 
                          className="form-control fw-bold text-muted bg-light" 
                          value={editFormData.tdsRate !== undefined && editFormData.tdsRate !== null ? editFormData.tdsRate : 0.10} 
                          readOnly 
                          placeholder="0.10"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="d-flex justify-content-between align-items-end mb-3">
                    <label className="fw-bold text-dark mb-0">Extracted Items</label>
                    <div className="d-flex gap-2">
                      {editFormData.poNumber && editFormData.poNumber.trim() !== "" && (
                        <button type="button" className="btn btn-sm btn-outline-success d-flex align-items-center gap-1" onClick={handleFetchPoItems}><DownloadCloud size={14}/> Fetch PO Items</button>
                      )}
                      <button type="button" className="btn btn-sm btn-outline-primary d-flex align-items-center gap-1" onClick={handleAddItemRow}><Plus size={14}/> Add Item</button>
                    </div>
                  </div>

                  <div className="table-responsive rounded-3 border bg-white">
                    <table className="table table-bordered mb-0">
                      <thead className="bg-light text-muted small text-uppercase">
                        <tr>
                          <th>Item Name / Description</th>
                          <th style={{width: '70px'}}>Quantity</th>
                          <th style={{width: '80px'}}>Rate (₹)</th>
                          <th style={{width: '90px'}}>Amount (₹)</th>
                          <th style={{width: '80px'}} title="Manual Override QTY PER ROW">Qty/Row</th>
                          <th style={{width: '40px'}} className="text-center">Del</th>
                        </tr>
                      </thead>
                      <tbody>
                        {editFormData.items.map((item, index) => (
                          <tr key={index}>
                            <td className="p-1">
                              <input type="text" className="form-control form-control-sm border-0 bg-transparent" value={item.name || item.description || ""} onChange={(e) => handleEditItemChange(index, "name", e.target.value)} required placeholder="Item Name"/>
                            </td>
                            <td className="p-1">
                              <input type="number" step="any" className="form-control form-control-sm border-0 bg-transparent text-center" value={item.qty || ""} onChange={(e) => handleEditItemChange(index, "qty", e.target.value)} placeholder="0"/>
                            </td>
                            <td className="p-1">
                              <input type="number" step="any" className="form-control form-control-sm border-0 bg-transparent text-end" value={item.rate || item.unitPrice || ""} onChange={(e) => handleEditItemChange(index, "rate", e.target.value)} required placeholder="0.00"/>
                            </td>
                            <td className="p-1 bg-light">
                              {/* LOCK: Item Amount ab ReadOnly hai aur auto calculate ho raha hai */}
                              <input type="number" step="any" className="form-control form-control-sm border-0 bg-transparent text-end fw-bold text-primary" value={item.amount || item.total || ""} readOnly placeholder="0.00"/>
                            </td>
                            <td className="p-1 bg-warning bg-opacity-10">
                              <input type="number" step="any" min="0" className="form-control form-control-sm border-0 bg-transparent text-center text-danger fw-bold" value={item.qtyPerRowOverride || ""} onChange={(e) => handleEditItemChange(index, "qtyPerRowOverride", e.target.value)} placeholder="Override"/>
                            </td>
                            <td className="p-1 text-center align-middle">
                              <button type="button" className="btn btn-sm text-danger p-0" onClick={() => handleRemoveItemRow(index)}><X size={16}/></button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="p-4 bg-white border-top d-flex justify-content-end gap-2">
                  <button type="button" className="btn btn-light fw-bold" onClick={() => setShowEditModal(false)}>Cancel</button>
                  <button type="submit" className="btn btn-primary fw-bold px-4" disabled={isUpdating}>{isUpdating ? "Saving..." : "Save Changes"}</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* ================= UPLOAD MODAL ================= */}
      {showUploadModal && (
        <div
          className="pi-upload-backdrop"
          onMouseDown={(event) => {
            if (event.target === event.currentTarget) closeUploadModal();
          }}
        >
          <section className="pi-upload-modal" role="dialog" aria-modal="true" aria-labelledby="pi-upload-title">
            <header className="pi-upload-header">
              <div className="pi-upload-heading">
                <div className="pi-upload-heading-icon" aria-hidden="true">
                  <FileText size={21} strokeWidth={2.2} />
                </div>
                <div>
                  <div className="pi-upload-eyebrow">PO OCR AI</div>
                  <h2 id="pi-upload-title">Scan purchase invoice</h2>
                  <p>Extract vendor, PO, items and totals from one bill.</p>
                </div>
              </div>
              <button type="button" className="pi-upload-close" onClick={closeUploadModal} disabled={isUploading} aria-label="Close invoice scanner">
                <X size={21} />
              </button>
            </header>

            <form onSubmit={handleUploadSubmit}>
              <div className="pi-upload-body">
                <input
                  ref={uploadInputRef}
                  type="file"
                  className="pi-upload-file-input"
                  onChange={(event) => selectUploadFile(event.target.files?.[0])}
                  accept=".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png"
                  tabIndex={-1}
                />

                <div
                  className={`pi-upload-dropzone${isUploadDragActive ? " is-dragging" : ""}${uploadFile ? " has-file" : ""}${uploadError ? " has-error" : ""}`}
                  role="button"
                  tabIndex={isUploading ? -1 : 0}
                  aria-disabled={isUploading}
                  onClick={() => !isUploading && uploadInputRef.current?.click()}
                  onKeyDown={(event) => {
                    if (!isUploading && (event.key === "Enter" || event.key === " ")) {
                      event.preventDefault();
                      uploadInputRef.current?.click();
                    }
                  }}
                  onDragEnter={(event) => {
                    event.preventDefault();
                    if (!isUploading) setIsUploadDragActive(true);
                  }}
                  onDragOver={(event) => event.preventDefault()}
                  onDragLeave={(event) => {
                    event.preventDefault();
                    if (!event.currentTarget.contains(event.relatedTarget)) setIsUploadDragActive(false);
                  }}
                  onDrop={(event) => {
                    event.preventDefault();
                    if (!isUploading) selectUploadFile(event.dataTransfer.files?.[0]);
                  }}
                >
                  {uploadFile ? (
                    <div className="pi-upload-selected">
                      <div className="pi-upload-preview" aria-hidden="true">
                        {uploadPreviewUrl ? <img src={uploadPreviewUrl} alt="" /> : <FileText size={34} strokeWidth={1.8} />}
                      </div>
                      <div className="pi-upload-file-info">
                        <span className="pi-upload-file-ready"><CheckCircle2 size={14} /> Ready to scan</span>
                        <strong title={uploadFile.name}>{uploadFile.name}</strong>
                        <span>{formatUploadFileSize(uploadFile.size)} · {uploadFile.name.split(".").pop()?.toUpperCase()}</span>
                      </div>
                      {!isUploading && (
                        <button type="button" className="pi-upload-remove" onClick={removeUploadFile} aria-label="Remove selected file">
                          <X size={17} />
                        </button>
                      )}
                    </div>
                  ) : (
                    <div className="pi-upload-empty">
                      <div className="pi-upload-drop-icon" aria-hidden="true"><Upload size={27} /></div>
                      <h3>{isUploadDragActive ? "Drop invoice to attach" : "Drop your invoice here"}</h3>
                      <p>or <span>browse from your computer</span></p>
                      <div className="pi-upload-format-row" aria-label="Supported file types">
                        <span>PDF</span><span>JPG</span><span>PNG</span>
                      </div>
                    </div>
                  )}
                </div>

                {uploadError && (
                  <div className="pi-upload-error" role="alert"><AlertCircle size={16} /> {uploadError}</div>
                )}

                {isUploading ? (
                  <div className="pi-upload-progress-panel" aria-live="polite">
                    <div className="pi-upload-progress-copy">
                      <div>
                        <strong>AI is reading your invoice</strong>
                        <span>Extracting details and validating them against the PO.</span>
                      </div>
                      <b>{uploadProgress}%</b>
                    </div>
                    <div className="pi-upload-progress-track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow={uploadProgress}>
                      <span style={{ width: `${uploadProgress}%` }} />
                    </div>
                  </div>
                ) : (
                  <div className="pi-upload-assurance">
                    <div><CheckCircle2 size={16} /><span><strong>Automatic checks</strong>Vendor, PO items and rates</span></div>
                    <div><ShieldAlert size={16} /><span><strong>Review protected</strong>Mismatches stay unverified</span></div>
                  </div>
                )}
              </div>

              <footer className="pi-upload-footer">
                <span className="pi-upload-footer-note">One invoice per upload</span>
                <div className="pi-upload-actions">
                  <button type="button" className="pi-upload-btn secondary" onClick={closeUploadModal} disabled={isUploading}>Cancel</button>
                  <button type="submit" className="pi-upload-btn primary" disabled={!uploadFile || isUploading}>
                    {isUploading ? <><span className="pi-upload-spinner" /> Scanning invoice</> : <><Upload size={17} /> Scan invoice</>}
                  </button>
                </div>
              </footer>
            </form>
          </section>
        </div>
      )}

      {/* OCR QTY MASTER MODAL */}
      <OCRQtyMasterModal show={showOcrQtyModal} onClose={() => setShowOcrQtyModal(false)} />

      {/* SETTINGS / AI PROMPT MODAL */}
      {showSettingsModal && (
        <div className="modal show d-block" style={{backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1055}}>
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content shadow-lg border-0 rounded-4">
              <div className="modal-header bg-light border-bottom-0 py-3">
                <h5 className="modal-title fw-bold text-dark d-flex align-items-center gap-2">
                  <Settings size={20} className="text-primary"/> AI Prompt Configuration
                </h5>
                <button type="button" className="btn-close" onClick={() => setShowSettingsModal(false)}></button>
              </div>
              <div className="modal-body p-4 bg-light">
                <div className="mb-3">
                  <label className="form-label fw-bold text-secondary small text-uppercase">System Prompt</label>
                  <textarea 
                    className="form-control font-monospace border-0 shadow-sm" 
                    rows="12" 
                    value={promptText} 
                    onChange={(e) => setPromptText(e.target.value)}
                    style={{fontSize: '13px', resize: 'none'}}
                  ></textarea>
                  <div className="form-text mt-2 text-muted">This prompt instructs the AI on how to parse the invoice and return JSON. Be careful modifying it.</div>
                </div>
              </div>
              <div className="modal-footer border-top-0 bg-light py-3">
                <button type="button" className="btn btn-white fw-bold px-4" onClick={() => setShowSettingsModal(false)}>Cancel</button>
                <button type="button" className="btn btn-primary fw-bold px-4 shadow-sm" onClick={handleSavePrompt} disabled={isSavingPrompt}>
                  {isSavingPrompt ? <div className="spinner-border spinner-border-sm text-light" role="status"></div> : "Save Prompt"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}

/* =========================================================
   UI COMPONENT FOR AI RESULT 
========================================================= */
const InvoiceResultView = ({ ocrResponse, onExport, exportingId, onExportTally, exportingTallyId, onEdit, onBack }) => {
  if (!ocrResponse) return null;

  const { status, mismatchDetails, data } = ocrResponse;
  const isVerified = status === 'GREEN' || status === 'APPROVED'; 

  // Parse items and taxes correctly
  const itemsList = data?.items?.items || data?.items || [];
  
  // Tax breakdown values
  const taxable = data?.taxableAmount || data?.items?.taxableAmount || 0;
  const cgst = data?.cgst || data?.items?.cgst || 0;
  const sgst = data?.sgst || data?.items?.sgst || 0;
  const igst = data?.igst || data?.items?.igst || 0;
  const grandTotal = data?.totalAmount || 0;

  // Bill-level charges & TDS
  const lu = data?.loadingUnloading || 0;
  const tr = data?.transportation || 0;
  const trGst = data?.transportationGst || 0;
  const trLocal = data?.transportationLocalScheme || 0;
  const tdsType = data?.tdsType || "TDS ON PURCHASE OF GOODS";

  return (
    <div style={{ background: "#fff", borderRadius: 20, border: "1px solid #e2e8f0", overflow: "hidden", marginTop: 24 }}>
      {/* Result header */}
      <div style={{ padding: "20px 24px", borderBottom: "1px solid #f1f5f9", display: "flex", justifyContent: "space-between", alignItems: "center", background: isVerified ? "#ecfdf5" : "#fef2f2" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          {onBack && (
            <button 
              onClick={onBack} 
              title="Back to Dashboard"
              style={{ background: "#fff", border: "1px solid #cbd5e1", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", width: 34, height: 34, borderRadius: "50%", color: "#334155", boxShadow: "0 2px 4px rgba(0,0,0,0.05)", flexShrink: 0, transition: "all 0.2s" }}
            >
              <ArrowLeft size={18} strokeWidth={2.5} />
            </button>
          )}
          <div>
            <h2 style={{ margin: 0, fontSize: 18, fontWeight: 800, color: "#0f172a" }}>AI Extraction Result</h2>
            <div style={{ fontSize: 12, color: "#64748b", marginTop: 4 }}>Bill #{ocrResponse.ID}</div>
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <StatusBadge status={status} />
          {onEdit && (
            <button onClick={() => onEdit(ocrResponse)} style={{ ...S.btn("primary"), fontSize: 12, marginRight: 8 }}>
              <Edit2 size={14}/> Edit
            </button>
          )}
          {status === 'APPROVED' && onExport && (
            <div style={{ display: "flex", gap: 8 }}>
              <button onClick={() => onExport(ocrResponse.ID)} disabled={exportingId === ocrResponse.ID} style={{ ...S.btn("success"), fontSize: 12 }}>
                <DownloadCloud size={14}/> {exportingId === ocrResponse.ID ? "Exporting..." : "Excel"}
              </button>
              {onExportTally && (
                <button onClick={() => onExportTally(ocrResponse.ID)} disabled={exportingTallyId === ocrResponse.ID} style={{ ...S.btn(), fontSize: 12 }}>
                  <DownloadCloud size={14}/> {exportingTallyId === ocrResponse.ID ? "Exporting..." : "Tally Format"}
                </button>
              )}
            </div>
          )}
        </div>
      </div>

      <div style={{ padding: 24 }}>
        
        {!isVerified && mismatchDetails && (
          <div style={{ background: "#fef2f2", border: "1px solid #fca5a5", borderLeft: "4px solid #ef4444", borderRadius: 12, padding: "16px 20px", marginBottom: 24 }}>
            <div style={{ fontWeight: 800, color: "#991b1b", display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
              <AlertCircle size={18}/> Mismatch Found
            </div>
            {mismatchDetails.split('|').map((err, i) => (
               <div key={i} style={{ fontSize: 13, color: "#b91c1c", marginBottom: 4 }}>• {err.trim()}</div>
            ))}
          </div>
        )}

        {/* Meta */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 16, background: "#f8fafc", borderRadius: 14, padding: "16px 20px", marginBottom: 24 }}>
          {[["Vendor Name", data?.partyName], ["PO Number", data?.poNumber], ["Bill Date", data?.date]].map(([k, v]) => (
            <div key={k}>
              <div style={{ fontSize: 10, fontWeight: 700, color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 4 }}>{k}</div>
              <div style={{ fontWeight: 700, fontSize: 14, color: "#0f172a" }}>{v || "—"}</div>
            </div>
          ))}
        </div>

        {/* Items table */}
        <div style={{ border: "1px solid #e2e8f0", borderRadius: 12, overflow: "hidden", marginBottom: 24 }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
            <thead>
              <tr style={{ background: "#0f172a" }}>
                {["Item Name / Description", "Qty", "Rate (₹)", "Amount (₹)"].map((h, i) => (
                  <th key={h} style={{ padding: "12px 16px", textAlign: i > 1 ? "right" : i === 1 ? "center" : "left", color: "#fff", fontSize: 10, textTransform: "uppercase", letterSpacing: "0.06em", fontWeight: 700 }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {itemsList.length > 0 ? itemsList.map((it, i) => (
                <tr key={i} style={{ borderBottom: "1px solid #f1f5f9" }}>
                  <td style={{ padding: "12px 16px", fontWeight: 600, color: "#1e293b" }}>{it.name || it.description || "Unknown"}</td>
                  <td style={{ padding: "12px 16px", textAlign: "center" }}><span style={{ background: "#f1f5f9", borderRadius: 6, padding: "4px 12px", fontSize: 12, fontWeight: 700 }}>{it.qty || 0}</span></td>
                  <td style={{ padding: "12px 16px", textAlign: "right", color: "#64748b", fontFamily: "monospace" }}>{fmt(it.rate || it.unitPrice)}</td>
                  <td style={{ padding: "12px 16px", textAlign: "right", fontFamily: "monospace", fontWeight: 800, color: "#0f172a" }}>{fmt(it.amount || it.total)}</td>
                </tr>
              )) : (
                <tr><td colSpan={4} style={{ padding: 32, textAlign: "center", color: "#94a3b8", fontStyle: "italic" }}>No items extracted.</td></tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Totals */}
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <div style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 14, padding: "16px 20px", minWidth: 260 }}>
            {[
              ["Loading / Unloading", lu],
              ["Transportation", tr],
              ["Transport + GST", trGst],
              ["Transportation(Local)/Scheme", trLocal],
              ["TDS Type", tdsType],
              ["---", "---"],
              ["Taxable Amount", taxable], 
              ["CGST", cgst], 
              ["SGST", sgst], 
              ["IGST", igst]
            ].map(([k, v], idx) => {
              if (k === "---") return <div key={idx} style={{ height: 1, background: "#e2e8f0", margin: "12px 0" }}></div>;
              return (
                <div key={k} style={{ display: "flex", justifyContent: "space-between", marginBottom: 8, fontSize: 12, color: "#64748b", fontWeight: k === "Taxable Amount" ? 700 : 500 }}>
                  <span>{k}</span>
                  <span style={{ fontFamily: "monospace" }}>₹{fmt(v)}</span>
                </div>
              );
            })}
            <div style={{ borderTop: "2px solid #e2e8f0", paddingTop: 10, marginTop: 4, display: "flex", justifyContent: "space-between", fontWeight: 800, fontSize: 16 }}>
              <span style={{ color: "#0f172a" }}>Grand Total</span>
              <span style={{ color: "#6366f1", fontFamily: "monospace" }}>₹{fmt(grandTotal)}</span>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};
